<template>
  <div class="c-filter">
    <form v-on:submit.prevent="formSubmit">
      <div class="grid-container">
        <div class="grid-x grid-margin-x o-columns__two">
          <div class="cell">
            <fieldset class="c-filter__fieldset">
              <legend class="c-filter__heading">Filter by section:</legend>
              <ul class="c-filter__list">
                <li 
                  class="c-filter__list-item"
                  v-for="(cat, i) in categories"
                  v-bind:key="i">
                  <input 
                    class="visually-hidden"
                    name="category"
                    type="checkbox"                     
                    v-bind:id="'cat' + i"
                    v-bind:value="cat.value"
                    v-model="category">
                  <label v-bind:for="'cat' + i">{{cat.label}}</label>
                </li>
              </ul>
            </fieldset>
          </div>
          <div class="cell">
            <label class="c-filter__heading" for="filter-search">Search by keyword:</label>
            <div class="c-filter__search">
              <input class="c-filter__search-field" id="filter-search" name="searchTerm" type="search" v-model="searchTerm">
              <button class="c-button c-button--brand" type="submit" v-bind:disabled="!searchTerm">Search</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "SearchFilter",
  props: {
    categories: {
      type: Array
    },
    searchTerm: {
      type: String
    }
  },
  data() {
    return {
      category: []
    }
  },
  methods: {
    formSubmit() {
      if (this.searchTerm) {
        this.$emit('formSearch', this.searchTerm, this.category);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/searches/results/SearchFilter.vue